import { Component, OnInit, Inject } from '@angular/core';
import { MessageDetailComponent } from './message-detail/message-detail.component';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-modal-missings',
  templateUrl: './modal-missings.component.html',
  styleUrls: ['./modal-missings.component.scss']
})
export class ModalMissingsComponent implements OnInit {
  displayedColumns: string[] = ['created_AT', 'updated_AT', 'entity_NAME', 'api_NAME', 'confirmation_TYPE', 'status', 'raw_ERROR', 'raw_DATA'];
  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  viewMessaje(origin, raw_DATA) {
    const data = []
    data.push({origin, message: raw_DATA})
    this.dialog.open(MessageDetailComponent, {
      data: data,
      disableClose: true,
      width: 'auto',
      maxWidth: '85vw'
    })
  }

}
